module.exports = __webpack_public_path__ + "img/avatar1.43ea2244.png";